$(function () {
fn_layout_header();
fn_layout_main();
fn_part_form();
fn_part_social();
fn_part_configuration_personalize();
fn_part_form_newsletter();
fn_part_form_ride();
fn_part_ui_carousel();
fn_part_ui_cookies();
fn_part_ui_input();
fn_part_ui_number();
fn_part_ui_select();
fn_part_ui_video();
fn_part_ui_wsw();
fn_comp_boxes();
fn_comp_detail_head();
fn_comp_detail_info();
fn_comp_parallax();
fn_comp_quotes();
fn_comp_visual();
});